import { useCommonTranslation } from 'hooks/i18n/useCommonTranslation';

import { ReportsLayout } from './ReportsLayout';
import { useSupervisorBodyData } from './SupervisorHooks';

export const Supervisor = () => {
  const { t } = useCommonTranslation();
  const bodyData = useSupervisorBodyData({ showLogOff: true });

  return <ReportsLayout title={t('supervisor')} {...bodyData} />;
};
